class Petition {
  constructor () {
    waitForElementToDisplay('#block-listesignatairespetition button.sign-petition', 200, this.openForm);
  }
  openForm() {
    let block = document.querySelector('#block-signpetitionblock');
    Array.prototype.forEach.call(document.querySelectorAll('.sign-petition'), function (elem) {
      elem.addEventListener('click', function (ev) {
        block.classList.add('open');
      })
    })
    block.querySelector('.icon-close').addEventListener('click', function(ev) {
      block.classList.remove('open');
    });
  }
}

function waitForElementToDisplay(selector, time, cb) {
  if (document.querySelector(selector)) {
    cb();
  }
  else {
    setTimeout(function() {
      waitForElementToDisplay(selector, time, cb);
    }, time);
  }
}

export default Petition;